module.exports = __webpack_public_path__ + "static/media/FENGYUN 2F.8f330198.czml";